import { Upload, Image as Picture } from 'antd';
import ImgCrop from 'antd-img-crop';
import { useState, useEffect } from 'react';

import { imagesService } from 'config/services';

import './UploadImages.scss';

interface UploadImagesProps {
  setImage: (index: number, newFile: string) => void;
  imageIndex: number;
  currentImage?: string;
}

export type imageDataType = {
  description: string;
  source: string;
};

export const ImageUpload = ({ setImage, imageIndex, currentImage }: UploadImagesProps) => {
  const [fileList, setFileList] = useState([]);

  const getSrcFromFile = (file: any) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
    });
  };

  const beforeUpload = async (file: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setFileList((prev): any => [...prev, { url: reader.result }]);
    };

    // then upload `file` from the argument manually.
    const { newstr } = await imagesService.upload({ file, onProgress: () => {} });

    // fileList[0].name = newstr;
    setImage(imageIndex, newstr);
    return newstr;
  };

  const onPreview = async (file: any) => {
    const src = file.url || (await getSrcFromFile(file));
    const imgWindow = window.open(src);

    if (imgWindow) {
      const image = new Image();
      image.src = src;
      imgWindow.document.write(image.outerHTML);
    } else {
      window.location.href = src;
    }
  };

  const onRemove = () => {
    setFileList([]);
  };
  return (
    <div className="imgContent">
      <ImgCrop aspect={0.75}>
        <Upload
          listType="picture-card"
          fileList={fileList}
          beforeUpload={beforeUpload}
          onPreview={onPreview}
          onRemove={onRemove}
          accept={'image/jpeg,image/jpg,image/png'}
        >
          {fileList.length < 1 && '+ Učitaj'}
        </Upload>
      </ImgCrop>
      {fileList.length < 1 && currentImage && (
        <Picture src={currentImage} alt="currentImage" className="picturePreview"></Picture>
      )}
    </div>
  );
};
